import { Injectable, OnDestroy } from '@angular/core';
import { filter, fromEvent, map, Observable, Subject, takeUntil } from 'rxjs';

export interface KeyPressEvent {
  key: string;
  code: string;
  altKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  metaKey: boolean;
  timestamp: number;
  target?: EventTarget | null;
  preventDefault: () => void;
  stopPropagation: () => void;
  stopImmediatePropagation: () => void;
}

@Injectable({ providedIn: 'root' })
export class HandleKeyPressService implements OnDestroy {
  private destroy$ = new Subject<void>();
  private keyPress$ = fromEvent<KeyboardEvent>(document, 'keydown');

  getAllKeyPresses(): Observable<KeyPressEvent> {
    return this.keyPress$.pipe(
      takeUntil(this.destroy$),
      map((event) => this.mapKeyboardEvent(event))
    );
  }

  getSpecificKeys(keys: string[]): Observable<KeyPressEvent> {
    return this.getAllKeyPresses().pipe(
      filter((event) => {
        return keys.includes(event.key);
      })
    );
  }

  private mapKeyboardEvent(event: KeyboardEvent): KeyPressEvent {
    return {
      key: event.key,
      code: event.code,
      altKey: event.altKey,
      ctrlKey: event.ctrlKey,
      shiftKey: event.shiftKey,
      metaKey: event.metaKey,
      timestamp: Date.now(),
      target: event.target,
      preventDefault: () => event.preventDefault(),
      stopPropagation: () => event.stopPropagation(),
      stopImmediatePropagation: () => event.stopImmediatePropagation(),
    };
  }

  stopTracking(): void {
    this.destroy$.next();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
